import './assets/styles/main.css';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import { shopifyConverter } from '@components/ShopifyConverter.js';

Alpine.plugin(collapse);
Alpine.data('shopifyConverter', shopifyConverter);
window.Alpine = Alpine;
Alpine.start();
